var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contact-dialog',{staticClass:"register-dialog",attrs:{"show":(_vm.show),"title":(_vm.title),"confirmText":"确认","content":(_vm.content)},on:{"confirm":_vm.confirmtDialog}},[_c('div',{staticClass:"inner-icon",attrs:{"slot":"icon"},slot:"icon"},[_c('mpx-image',{staticClass:"inner-image",attrs:{"src":(_vm.icon)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }